<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-risk-warning`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41 18.441C41 8.821 33.402 1 24 1 14.598 1 7 8.821 7 18.441c0 4.174 2.369 8.529 6.955 13.124A7 7 0 0116 36.51v.46c0 1.66 1.33 3.03 3 3.03h10c1.67 0 3-1.37 3-3.03v-.46a7 7 0 012.045-4.945C38.631 26.969 41 22.615 41 18.44zM31 43a1 1 0 00-1-1H18a1 1 0 00-1 1v2a1 1 0 001 1h12a1 1 0 001-1v-2zM24 5c-7.166 0-13 6.005-13 13.441 0 2.93 1.878 6.382 5.786 10.298A11 11 0 0119.988 36h8.024a11 11 0 013.202-7.26C35.122 24.822 37 21.37 37 18.44 37 11.005 31.166 5 24 5zm1.267 4.454l-.107-.047a1 1 0 00-1.238.484l-4.086 8.02-.048.109a.997.997 0 00-.061.34l-.047.106a1 1 0 00.484 1.238l4.456 2.27-2.725 5.346-.047.107a1 1 0 00.484 1.238l1.782.908.107.047a1 1 0 001.238-.484l4.086-8.019.047-.107a1 1 0 00-.484-1.238l-1.782-.908-2.767-1.41 2.927-5.747.047-.107a1 1 0 00-.484-1.238l-1.782-.908z"/></svg>
</template>
<script>

export default {
  name: 'IconRiskWarning',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
